import ApolloClient from "apollo-boost";
import { getToken, getImpersonationHeader } from "../lib/auth";

export const getAuthHeader = (token) =>
  token && { Authorization: `Bearer ${token}` };

const apolloClient = new ApolloClient({
  uri: `${process.env.REACT_APP_V3_API_HOST}`,
  request: async (operation) => {
    let token;
    try {
      token = await getToken();
    } catch (e) {
      token = null;
    }

    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        ...getAuthHeader(token),
        ...getImpersonationHeader(),
      },
    }));
  },
  clientState: {},
});

export default apolloClient;
